import { render, staticRenderFns } from "./CardDashboard.vue?vue&type=template&id=152fcdb0&scoped=true&"
import script from "./CardDashboard.vue?vue&type=script&lang=js&"
export * from "./CardDashboard.vue?vue&type=script&lang=js&"
import style0 from "./CardDashboard.vue?vue&type=style&index=0&id=152fcdb0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "152fcdb0",
  null
  
)

export default component.exports